import React, { Component } from "react";
import Year from "./Year";
import LightboxImage from "./LightboxImage";
import LightboxVideo from "./LightboxVideo";

import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";

class Gallery extends Component {
  constructor(props) {
    super(props);

    this.state = {
      mediaIndex: 0,
      mediaSource: "",
      isOpen: false,
      videoRefs: []
    };

    this.gallery = [];
    this.slides = [];
    this.buildGallery(props.media?.allMedia || {});
  }

  componentDidUpdate(prevProps) {
    // Rebuild gallery if media prop changes (shallow check is fine for this use)
    if (prevProps.media !== this.props.media) {
      const prevCurrentUrl = this.slides?.[this.state.mediaIndex]?.info?.url;
      this.buildGallery(this.props.media?.allMedia || {});
      // Try to keep the same current item selected if it still exists
      if (prevCurrentUrl) {
        const newIdx = this.slides.findIndex((s) => s.info?.url === prevCurrentUrl);
        if (newIdx >= 0) {
          // keep index
          this.setState({ mediaIndex: newIdx });
        } else {
          // reset if prior item no longer exists
          this.setState({ mediaIndex: 0, isOpen: false });
        }
      }
    }
  }

  buildGallery(allMedia) {
    const list = [];
    for (const [, contentTypes] of Object.entries(allMedia)) {
      const formats = Object.entries(contentTypes);
      for (const [, format] of formats) {
        const displayedFormat = this.getMediaFormat(format);
        if (displayedFormat && typeof displayedFormat === "object") {
          const firstKey = Object.keys(displayedFormat)[0];
          const item = displayedFormat[firstKey];
          if (item && item.url) {
            list.push(item);
          }
        }
      }
    }
    // Recent first to match original behavior
    list.reverse();
    this.gallery = list;
    // Provide src for preloading; we render custom content via `render.slide`
    this.slides = this.gallery.map((m) => ({ src: m.url, info: m }));
  }

  handleClick = (source) => {
    const itemIndex = this.gallery.findIndex((el) => el.url === source);
    if (itemIndex >= 0) {
      this.setState({ isOpen: true, mediaIndex: itemIndex });
    }
  };

  renderLightbox() {
    const total = this.slides.length;
    const { mediaIndex, isOpen } = this.state;

    if (!total || !this.slides[mediaIndex]) return null;

    return (
      <Lightbox
        open={isOpen}
        close={() => this.setState({ isOpen: false })}
        index={mediaIndex}
        slides={this.slides}
        on={{
          view: ({ index }) => this.setState({ mediaIndex: index })
        }}
        controller={{ closeOnBackdropClick: true }}
        carousel={{ finite: total <= 1 }}
        // Render your existing components for each slide (current, prev, next)
        render={{
          slide: ({ slide, offset }) => {
            const idx = (mediaIndex + offset + total) % total;
            const info = slide.info || this.gallery[idx];
            const common = { info, total, index: idx, current: offset === 0 };
            const isVideo = info ? this.getIsVideo(info) : false;
            return isVideo ? <LightboxVideo {...common} /> : <LightboxImage {...common} />;
          }
        }}
      />
    );
  }

  // Display the annual groupings of media tiles
  renderYears(allMedia, childData) {
    const yearKeys = Object.keys(allMedia || {}).sort((a, b) => b - a);
    return yearKeys.map((yearKey) => (
      <Year
        year={yearKey}
        key={yearKey}
        mediaData={allMedia[yearKey]}
        handleClick={this.handleClick}
        getIsVideo={this.getIsVideo}
        getMediaFormat={this.getMediaFormat}
        childData={childData}
      />
    ));
  }

  // Prefer non-video display formats in order: web -> original -> vthumb -> first available
  getMediaFormat(media) {
    if (!media || typeof media !== "object") return media;
    if (media.web) return media.web;
    if (media.original) return media.original;
    if (media.vthumb) return media.vthumb;
    return media;
  }

  // Videos end with "V" per contentTypeCode
  getIsVideo = (media) => {
    const code = media?.contentTypeCode || "";
    return code.slice(-1).toUpperCase() === "V";
  };

  render() {
    const { visible, media, childData } = this.props;
    if (visible === false) return null;

    const { isOpen } = this.state;
    const showLightbox = typeof window !== "undefined"
      ? window.matchMedia("(min-width: 768px)").matches
      : true;

    return (
      <div className="container" style={{ maxWidth: "960px", margin: "0 auto" }}>
        <div className="Gallery child-gallery">
          {this.renderYears(media?.allMedia || {}, childData)}
          {isOpen && showLightbox && this.renderLightbox()}
        </div>
      </div>
    );
  }
}

export default Gallery;
